/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  ApiCloneExistingCredentialsRequest,
  ErrorResponse,
  ProcessAuthorizationCode2Params,
  UrlResponse,
  UserAlreadyConnectedResponse,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiMetaController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-meta-controller
   * @name CloneExistingCredentials1
   * @request POST:/api/v1/document-fetcher/meta/clone
   */
  cloneExistingCredentials = (
    data: ApiCloneExistingCredentialsRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/document-fetcher/meta/clone`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static cloneExistingCredentialsPath = '/v1/document-fetcher/meta/clone'
  static cloneExistingCredentialsMethod = 'POST'
  /**
   * No description
   *
   * @tags api-meta-controller
   * @name ProcessAuthorizationCode2
   * @summary Gets OAuth2 code and tries to establish an integration
   * @request GET:/api/v1/document-fetcher/meta/oauth2code
   */
  processAuthorizationCode = (query: ProcessAuthorizationCode2Params, params: RequestParams = {}) =>
    this.http.request<void, ErrorResponse>({
      path: `/v1/document-fetcher/meta/oauth2code`,
      method: 'GET',
      query: query,
      ...params,
    })

  static processAuthorizationCodePath = '/v1/document-fetcher/meta/oauth2code'
  static processAuthorizationCodeMethod = 'GET'
  /**
   * No description
   *
   * @tags api-meta-controller
   * @name GetAuthorizationCodeRequestUrl2
   * @summary Gets URL to redirect a user to in order to start OAuth consent flow
   * @request GET:/api/v1/document-fetcher/meta/authorizationCodeRequestUrl
   */
  getAuthorizationCodeRequestUrl = (params: RequestParams = {}) =>
    this.http.request<UrlResponse | UserAlreadyConnectedResponse, ErrorResponse>({
      path: `/v1/document-fetcher/meta/authorizationCodeRequestUrl`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getAuthorizationCodeRequestUrlPath =
    '/v1/document-fetcher/meta/authorizationCodeRequestUrl'
  static getAuthorizationCodeRequestUrlMethod = 'GET'
}
